module.exports = __webpack_public_path__ + "img/5.7321913d.webp";